export default {
    async importFileToArray(file, selectedDepId) {
        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.readAsText(file, 'big5');
    
            reader.onload = function(event) {
                //為了應付IE11 big5 transcode
                let transferResult = event.target.result.replace(event.target.result.split(',')[0], 'name');
    
                //讀入所匯入的CSV格式
                let csvFile = window.jQuery.csv.toObjects(transferResult);
                
                for(var i = 0 ; i < csvFile.length ; i++) {
                    //代表使用者沒有自訂欄位,那就照順序填入
                    if(csvFile[0].hasOwnProperty('name') === false) {
                        csvFile[i].name = csvFile[i][Object.getOwnPropertyNames(csvFile[i])[0]];
                        csvFile[i].password = csvFile[i][Object.getOwnPropertyNames(csvFile[i])[1]];
                        csvFile[i].displayName = csvFile[i][Object.getOwnPropertyNames(csvFile[i])[2]];
                        csvFile[i].email = csvFile[i][Object.getOwnPropertyNames(csvFile[i])[3]];
                        csvFile[i].level = csvFile[i][Object.getOwnPropertyNames(csvFile[i])[4]];
                    }
                    csvFile[i].selectedDepId = selectedDepId;
                    csvFile[i].isManager = 0;
                    csvFile[i].status = 1;
                }

                resolve(csvFile);
            };

            reader.onerror = function() {
                reject('匯入帳號 CSV 錯誤!');
            };
        });
    },

    async importUpdatesToArray(file, selectedDepId) {
        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.readAsText(file);

            let that = this;
    
            reader.onload = function(event) {
                //讀入所匯入的CSV格式
                let csvFile = window.jQuery.csv.toObjects(event.target.result);
                csvFile.forEach((obj) => {
                    that.renameKey(obj, '原工號', 'name');
                    that.renameKey(obj, '新工號', 'new_id');
                    that.renameKey(obj, '姓名', 'displayname');
                    that.renameKey(obj, 'e-Mail', 'email');
                    that.renameKey(obj, 'Level', 'level');
                    obj.selectedDepId = selectedDepId;
                });
                resolve(csvFile);
            };

            reader.onerror = function() {
                reject('匯入帳號 CSV 錯誤!');
            };
        });
    },

    renameKey(obj, oldKey, newKey) {
        obj[newKey] = obj[oldKey];
        delete obj[oldKey];
    },
}


// WEBPACK FOOTER //
// ./src/common/js/account.js